import React from 'react';

import { Dropdown } from 'semantic-ui-react';
import Link from '../../../atoms/Link';
import { isExternalPage } from '../../../services/pages';

export default ({ title, options, linksAs }) => {
  return (
    <Dropdown item text={title}>
      <Dropdown.Menu>
        {options.map(({ title: linkTitle, as, pageType, slug, url, ...rest }, index) => (
          <Dropdown.Item key={linkTitle}>
            <Link
              to={isExternalPage(pageType) ? url : slug}
              linkAs={as || linksAs}
              title={linkTitle}
              internal={!isExternalPage(pageType)}
              {...rest}
            />
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
